export default {"src":"/_next/static/media/visa.a388c8d4.svg","height":14,"width":34,"blurWidth":0,"blurHeight":0};